import { collectionGroup, where } from 'firebase/firestore';
import _ from 'lodash';
import { convertHelpers } from '../../../../../global/common/convert';
import { createRefPath, createRefPath_event } from '../../../../../global/firestoreData/appData/appRefPaths';
import { getSportsYear } from '../../../../../global/firestoreData/helpers/years';
import { seasonalHelpers } from './seasonalSportsData';

const _dpIgnores = ['allSportsYears', 'schools', 'sports', 'sportsTeams', 'staff', 'teams']

/**
 * Get data from the `_collectionName` with some `dataParent` and `additionalDataParent` constraints
 * @param {string} collectionName 
 * @param {object} pathViews 
 * @param {object} dataParents 
 * @param {function} callback 
 * @param {string} altCollectionName 
 * @returns via callback data from a document based on the collectionName WHERE the `parentKeys` constraints are correct
 */
export const getParentKeyData_sports = async (pkdProps) => {

  const { database_fns, pathViews, dataItem, dataParents, callback, additionalDataParents, sportsKey, latestSeason, cbProps, _refPaths } = pkdProps

  const {
    allDocs,
    collectionDocField,
    collectionName,
    collectionSub,
    collectionSubDoc,
    collectionSubs,
    ignoreDistrict,
    isSubCollection,
    noPrefix,
    noSeasonal,
    noYear,
    noListen,
    specificYear,
    subItemKey,
    renderAs,
  } = dataItem ?? {}

  const _latestSeason = specificYear ? specificYear : latestSeason
  const _listen = true // noListen ? false : true

  let _collectionName = collectionName
  _collectionName = noSeasonal || noPrefix ? collectionName : '_' + _collectionName

  /**
   * combines the data from the 
   * @param {*} dataSubs 
   * @param {*} sbProps 
   */
  const _callbackSub = (dataSubs, sbProps) => {

    // dataSubs contains child data object. We want to combine them into one object (sub).

    let _combinedData = {}
    const { sub } = sbProps ?? {}

    if (dataSubs && sub) {
      _.forEach(dataSubs, (dataItem, dik) => {
        const subData = dataItem[sub]
        // add _matchCollectionKey to the data
        convertHelpers.createItemPropValues(subData, subItemKey, dik)
        _combinedData = { ..._combinedData, ...subData }
      })
    }

    const _subData = { [sub]: _combinedData }
    const _opts = { ...sbProps, collectionDocField, _latestSeason, cbProps, collectionName, dataItem }

    callback(_subData, _opts)

  }

  /**
   * handles the callback for the get_data call.
   * @param {object} data 
   * @param {object} opts 
   */
  const _callbackLocal = async (data, opts) => {

    const { item: _data, _hasMultipleObjects } = data
    const { _itemKey } = _data ? _data : {}

    const _cbProps = cbProps ? { ...cbProps, itemKey: _itemKey } : { itemKey: _itemKey }
    const _opts = { ...opts, renderAs, collectionDocField, _latestSeason, cbProps: _cbProps, collectionName, dataItem, _hasMultipleObjects }

    // if (collectionSubs) {
    //   if (_itemKey) {
    //     const xxx = await getDocSubs({ pathViews, collectionName: _collectionName, itemKey: _itemKey, collectionSubs, database_fns, dataItem })
    //     const yyy = mergeSubData(xxx, dataItem)
    //     console.log('yyy', yyy)
    //     // const _opts = { dataItem, collectionSubs }
    //     // callback(yyy, _opts)
    //     _.forEach(collectionSubs, (_collectionSub) => {
    //       const _refPathSub = createRefPath_event(pathViews, [_collectionName, _itemKey, _collectionSub])
    //       database_fns.get_data({ refPath: _refPathSub, callback: _callbackSub, opts: { listen: _listen, cbProps: { itemKey: _itemKey, sub: _collectionSub, _refPath: _refPathSub } } })
    //     })
    //   } else {
    //     _.forEach(collectionSubs, (_collectionSub) => {
    //       const opts = { sub: _collectionSub }
    //       callback({}, opts)
    //     })
    //   }
    // } else {
    //   if (allDocs && _collectionName === '_tournaments_alumni') {
    //     callback(data, _opts)
    //   } else {
    callback(_data, _opts)
    // }
    // }
  }

  let _refPath;
  if (collectionSub && !isSubCollection) {
    if (collectionSubDoc) {
      _refPath = createRefPath_event(pathViews, [_collectionName, collectionSub, collectionSubDoc])
    } else {
      _refPath = createRefPath_event(pathViews, [_collectionName, collectionSub])
    }
  } else {
    _refPath = createRefPath_event(pathViews, [_collectionName])
  }


  const getWheres = () => {

    const wheres = [];
    const wherez = [];

    let _hasDistrict = false;
    let _orderBy;
    let dataLimit;

    const addWhere = (field, value) => {
      if (!_.some(wheres, { fieldPath: field, opStr: '==', value })) {
        wheres.push(where(field, '==', value));
      }
    };

    const addWherez = (pk, value) => {
      if (!_.some(wherez, { pk, value })) {
        wherez.push({ pk, value });
      }
    };

    if (dataParents) {
      dataParents.forEach(dp => {
        if (!_dpIgnores.includes(dp) && pathViews[dp]) {
          addWhere('parentKeys.' + dp, pathViews[dp]);
          addWherez(dp, pathViews[dp]);
          if (dp === 'district') _hasDistrict = true;
        }
      });
    }

    if (additionalDataParents) {
      additionalDataParents.forEach(dp => {
        switch (dp) {
          case 'sports':
            const value = sportsKey || pathViews[dp];
            if (value) {
              addWhere('parentKeys.' + dp, value);
              addWherez(dp, value);
            }
            break;
          case 'sportsYear':
            if (latestSeason && !noYear) {
              const sportsYear = getSportsYear(latestSeason);
              addWhere('parentKeys.sportsYears', sportsYear);
              addWherez('sportsYears', sportsYear);
            }
            break;
          default:
            if (pathViews[dp]) {
              addWhere('parentKeys.' + dp, pathViews[dp]);
              addWherez(dp, pathViews[dp]);
            }
        }
      });
    }

    if (!ignoreDistrict && !_hasDistrict && pathViews['districts']) {
      addWhere('parentKeys.districts', pathViews['districts']);
      addWherez('districts', pathViews['districts']);
    }

    return { wheres, wherez, _orderBy, dataLimit };
  };


  const { wheres, wherez, _orderBy, dataLimit } = getWheres()

  if (_refPaths) {
    _refPaths.push(_refPath)
  }

  if (database_fns) {
    database_fns.get_data({ refPath: _refPath, wheres, callback: _callbackLocal, opts: { cbProps: { _refPath, wherez }, _orderBy, dataLimit, listen: _listen, returnFirstObject: allDocs ? false : true, warnMultipleObjects: true, warnMultipleObjectIndex: 1 } })
  }

}

export const getDocNormals = async ({
  props
}) => {

  const {
    additionalDataParents,
    database_fns,
    dataItems,
    dataParents,
    pathViews,
    selectedSeason,
    sportsKey,
  } = props

  const _refPaths = []

  return new Promise((resolve) => {
    const allResults = {};
    let completed = 0;

    // const _dataItems = _.pickBy(dataItems, (item) => !item.collectionSubs);

    const total = _.size(dataItems);

    _.forEach(dataItems, (dataItem) => {

      // const refPath = createRefPath_event(pathViews, [collectionName, itemKey, dataItem]);
      const callback = (result) => {
        // save the data for this subcollection 
        allResults[dataItem?._dataItemKey] = result || {};
        completed++;
        // once all subcollections have reported once, resolve
        if (completed === total) {
          resolve(allResults);
        }
      };

      const pkdProps = {
        _refPaths, // a empty collection that will contain all the refPaths called
        additionalDataParents, // from props 
        database_fns, // the global database function
        dataItem, // an object containing info about what data to get
        dataParents, // an object containing the dataParents
        latestSeason: selectedSeason, // the season
        pathViews, // the pathViews
        sportsKey, // the sportsKey
        callback: callback,
      }
      getParentKeyData_sports(pkdProps)
      // start listening to this subcollection
    });
  });
};

export const getDocSubz = async ({
  props,
  dataItem,
  itemKey,
  listen = true,
}) => {

  const { pathViews, database_fns } = props ?? {}

  return new Promise((resolve) => {
    const allResults = {};
    let completed = 0;

    const { collectionSubs, collectionName } = dataItem
    const _collectionName = `_${collectionName}`
    const total = collectionSubs.length;

    _.forEach(collectionSubs, (subName) => {
      const refPath = createRefPath_event(pathViews, [_collectionName, itemKey, subName]);
      const callback = (result) => {
        // save the data for this subcollection 
        allResults[subName] = result;
        completed++;

        // once all subcollections have reported once, resolve
        if (completed === total) {
          resolve(allResults);
        }
      };

      // start listening to this subcollection
      database_fns.get_data({ refPath, callback, opts: { listen, cbProps: { itemKey, sub: subName, _refPath: refPath }, }, });
    });
  });
};

/**
 * Fetch multiple subcollections and resolve when all have their initial snapshots.
 * Keeps listeners active if listen=true.
 */
export const getDocSubs = async ({
  pathViews,
  collectionName,
  itemKey,
  collectionSubs,
  database_fns,
  listen = true,
  dataItem,
}) => {
  return new Promise((resolve) => {
    const allResults = {};
    let completed = 0;

    const total = collectionSubs.length;

    _.forEach(collectionSubs, (subName) => {
      const refPath = createRefPath_event(pathViews, [collectionName, itemKey, subName]);
      const callback = (result) => {
        // save the data for this subcollection 
        allResults[subName] = result;
        completed++;

        // once all subcollections have reported once, resolve
        if (completed === total) {
          resolve(allResults);
        }
      };

      // start listening to this subcollection
      database_fns.get_data({ refPath, callback, opts: { listen, cbProps: { itemKey, sub: subName, _refPath: refPath }, }, });
    });
  });
};

export const mergeSubData = (subData, dataItem) => {
  const _subDataCombined = {}
  if (subData) {
    _.forEach(subData, (subDataItem, dik) => { // matches, playoffMatches, etc.
      let _combinedData = {}
      _.forEach(subDataItem, (data, k) => { // 1A, 2A, etc.
        const diData = data[dik]
        // add _matchCollectionKey to the data
        convertHelpers.createItemPropValues(diData, dataItem?.subItemKey, k)
        _combinedData = { ..._combinedData, ...diData }
      })
      _subDataCombined[dik] = _combinedData
    })
  }
  return _subDataCombined
}

export const updateParentKeyData_sports = async (database_fns, sportPermissions, collectionName, pathViews, fieldName, data, callback, sportsKey) => {

  const _allowUpdate = sportPermissions.any && sportPermissions.parentKeySportsData ? true : false

  const _callback = (parentalItem) => {

    if (parentalItem) {

      const existingParentalItem = parentalItem[Object.keys(parentalItem)[0]]

      const _refPath = createRefPath_event(pathViews, [collectionName])

      const updateData = { [fieldName]: data }

      try {
        if (existingParentalItem) {
          const _updateRef = createRefPath([existingParentalItem.id], _refPath)
          if (_allowUpdate) {
            database_fns.set_doc(_updateRef, updateData, true, callback)
          } else {
            console.log('_updateRef', _updateRef, updateData)
          }
        } else {
          // ADD ??? 
        }
      } catch (error) {
        console.log('updateParentKeyData - error', error)
      }
    }
  }

  getParentalForUpdate(database_fns, pathViews, collectionName, sportsKey, _callback)

}

const getParentalForUpdate = (database_fns, pathViews, collectionName, sportsKey, callback) => {

  const _refPath = createRefPath_event(pathViews, [collectionName])
  const wheres = []

  const _pks = seasonalHelpers.getPks(pathViews)

  Object.keys(_pks).forEach(pkk => {
    switch (pkk) {
      case 'sports':
        wheres.push(where('parentKeys.' + pkk, '==', sportsKey))
        break;
      default:
        wheres.push(where('parentKeys.' + pkk, '==', _pks[pkk]))
    }
  })

  database_fns.get_data({ refPath: _refPath, callback, wheres })

}
